import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";

import { Container, Card, Col, Row } from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";

import {
  Form,
  Select,
  Table,
  Space,
  Tag,
  Button,
  Modal,
  Input,
  Image,
} from "antd";

import Loader from "../../global/Loader";

import { AuthenticationService } from "../../Services/AuthService";
import { ImageGalleryService } from "../../Services/ImageGalleryService";
import { CommonServices } from "../../Services/CommonService";

import Swal from "sweetalert2";

import { IoPersonAddSharp } from "react-icons/io5";

import demoUser from "../../assets/images/demo-user.jpg";
import loadingImg from "../../assets/images/loading-img.gif";


const MapGalleryList = () => {

  /* =========================================================
     SERVICES
  ========================================================= */

  const authService = useMemo(
    () => new AuthenticationService(),
    []
  );

  const commonService = useMemo(
    () => new CommonServices(),
    []
  );

  const imageGalleryService = useMemo(
    () => new ImageGalleryService(),
    []
  );

  const navigate = useNavigate();


  /* =========================================================
     USER
  ========================================================= */

  const currentUser = authService.getUserData?.role;


  /* =========================================================
     STATE
  ========================================================= */

  const [tblData, setTblData] = useState([]);

  const [loadingTblData, setLoadingTblData] = useState(false);

  const [commonListData, setCommonListData] = useState([]);

  const [loadingFilterList, setLoadingFilterList] = useState(false);

  const [actionStatusData, setActionStatusData] = useState([]);

  const [modal1Open, setModal1Open] = useState(false);

  const [modalStatus, setModalStatus] = useState([]);

  const [modalTitle, setModalTitle] = useState("");

  const [formShowHide, setFormShowHide] = useState(false);

  const [loadingModalSubmit, setLoadingModalSubmit] = useState(false);

  const [imageId, setImageId] = useState(null);

  const [filterType, setFilterType] = useState({
    filterType: "-1",
  });


  /* =========================================================
     ANT DESIGN FORMS
  ========================================================= */

  const [form] = Form.useForm();

  const [form2] = Form.useForm();


  /* =========================================================
     PAGINATION
  ========================================================= */

  const [currentPage, setCurrentPage] = useState(1);

  const [pageSize, setPageSize] = useState(10);


  /* =========================================================
     IMAGE CACHE
     
     इसमें downloaded image URLs रखे जाएंगे।
     इससे same image दोबारा API से download नहीं होगी।
  ========================================================= */

  const imageCacheRef = useRef({});


  /* =========================================================
     GET IMAGE BY ID
     
     केवल current page की images के लिए call होगा।
  ========================================================= */

  const getImageById = useCallback(
    async (docUniqueId, docMimeType) => {

      if (!docUniqueId) {
        return demoUser;
      }


      /* -------------------------------------------------------
         Cache में image मौजूद है तो API call नहीं होगी
      ------------------------------------------------------- */

      if (imageCacheRef.current[docUniqueId]) {
        return imageCacheRef.current[docUniqueId];
      }


      try {

        const res =
          await imageGalleryService.ViewDocument(
            docUniqueId
          );


        if (res.status === 200) {

          const fileBlob = new Blob(
            [res.data],
            {
              type: docMimeType,
            }
          );


          const dataUrl =
            URL.createObjectURL(fileBlob);


          /* ---------------------------------------------------
             Image URL cache में save करें
          --------------------------------------------------- */

          imageCacheRef.current[docUniqueId] =
            dataUrl;


          return dataUrl;
        }

      }
      catch (error) {

        console.error(
          "Error fetching image:",
          error
        );

      }


      return demoUser;
    },
    [imageGalleryService]
  );


  /* =========================================================
     LOAD ONLY CURRENT PAGINATION PAGE IMAGES
  ========================================================= */

  useEffect(() => {

    if (!tblData.length) {
      return;
    }


    /* -------------------------------------------------------
       Current page का starting index
    ------------------------------------------------------- */

    const startIndex =
      (currentPage - 1) * pageSize;


    /* -------------------------------------------------------
       Current page के records
    ------------------------------------------------------- */

    const currentPageData =
      tblData.slice(
        startIndex,
        startIndex + pageSize
      );


    /* -------------------------------------------------------
       Current page images load करें
    ------------------------------------------------------- */

    const loadCurrentPageImages = async () => {

      await Promise.all(

        currentPageData.map(
          async (item) => {

            if (!item.docUniqueId) {
              return;
            }


            /* -----------------------------------------------
               Cache में image है तो skip करें
            ------------------------------------------------ */

            if (
              imageCacheRef.current[
                item.docUniqueId
              ]
            ) {
              return;
            }


            const imageUrl =
              await getImageById(
                item.docUniqueId,
                item.docMimeType
              );


            /* -----------------------------------------------
               केवल उसी record का image URL update करें
            ------------------------------------------------ */

            setTblData((prevData) =>
              prevData.map((row) =>
                row.docUniqueId ===
                item.docUniqueId
                  ? {
                      ...row,
                      ImgUrl: imageUrl,
                    }
                  : row
              )
            );

          }
        )

      );

    };


    loadCurrentPageImages();

  }, [
    tblData.length,
    currentPage,
    pageSize,
    getImageById,
  ]);


  /* =========================================================
     FILTER LIST + ACTION STATUS
  ========================================================= */

  useEffect(() => {

    const getFilterList = async () => {

      try {

        setLoadingFilterList(true);


        const res =
          await commonService.getActionCommonStatus();


        const filterData =
          res.data?.filter(
            (item) =>
              item.value === "0" ||
              item.value === "1" ||
              item.value === "3"
          ) || [];


        const data = [
          {
            value: "-1",
            name: "All",
            label: "All",
            nameHindi: "",
            type: "",
            extraField1: "",
          },
        ];


        filterData.forEach((item) => {

          data.push({

            value: item.value,

            name: item.name,

            label: item.label,

            nameHindi: item.nameHindi,

            type: item.type,

            extraField1: item.extraField1,

          });

        });


        setCommonListData(data);

      }
      catch (error) {

        console.error(
          "Error loading filter list:",
          error
        );

      }
      finally {

        setLoadingFilterList(false);

      }

    };


    const getActionStatus = async () => {

      try {

        const res =
          await commonService.getActionStatus();


        setActionStatusData(
          res.data || []
        );

      }
      catch (error) {

        console.error(
          "Error loading action status:",
          error
        );

      }

    };


    getFilterList();

    getActionStatus();

  }, [commonService]);


  /* =========================================================
     LOAD MAP GALLERY TABLE DATA
     
     IMPORTANT:
     यहाँ ViewDocument() call नहीं होगी।
     केवल metadata आएगा।
  ========================================================= */

  useEffect(() => {

    const getMapGalleryList = async () => {

      try {

        setLoadingTblData(true);


        const payload = {

          isActive: -1,

          verificationStatus:
            filterType.filterType,

          imageId: 0,

          imageCategoryType: -1,

          galleryType: 3,

        };


        const res =
          await imageGalleryService.GetImageDetails(
            payload
          );


        const tableData =
          res.data?.table || [];


        /* ---------------------------------------------------
           पुराने cached Blob URLs revoke करें
           
           Filter change होने पर पुरानी cache clear होगी।
        --------------------------------------------------- */

        Object.values(
          imageCacheRef.current
        ).forEach((url) => {

          if (
            typeof url === "string" &&
            url.startsWith("blob:")
          ) {

            URL.revokeObjectURL(url);

          }

        });


        imageCacheRef.current = {};


        /* ---------------------------------------------------
           केवल table metadata तैयार करें
           
           यहाँ image download नहीं होगी।
        --------------------------------------------------- */

        const data =
          tableData.map(
            (item, index) => ({

              key: index + 1,

              imageId:
                item.imageId,

              imagenotes:
                item.imagenotes,

              actionId:
                item.actionId,

              verificationStatus:
                item.verificationStatus,

              statusName:
                item.statusName,

              isActive:
                item.isActive,

              isActiveName:
                item.activeName,

              submitDate:
                item.submitDate,

              docUniqueId:
                item.docUniqueId,

              docMimeType:
                item.docMimeType,

              verificationremark:
                item.verificationRemark,

              publishDate:
                item.publishDate,

              /* ---------------------------------------------
                 शुरुआत में loading image
              --------------------------------------------- */

              ImgUrl:
                loadingImg,

            })
          );


        setTblData(data);


        /* ---------------------------------------------------
           Filter change पर first page
        --------------------------------------------------- */

        setCurrentPage(1);

      }
      catch (error) {

        console.error(
          "Error loading map gallery:",
          error
        );

        setTblData([]);

      }
      finally {

        setLoadingTblData(false);

      }

    };


    getMapGalleryList();

  }, [
    filterType,
    imageGalleryService,
    loadingModalSubmit,
  ]);


  /* =========================================================
     FILTER CHANGE
  ========================================================= */

  const loadTableFilter = (value) => {

    setFilterType({
      filterType: value,
    });

  };


  /* =========================================================
     PAGINATION CHANGE
  ========================================================= */

  const handleTableChange = (
    pagination
  ) => {

    setCurrentPage(
      pagination.current
    );

    setPageSize(
      pagination.pageSize
    );

  };


  /* =========================================================
     EDIT
  ========================================================= */

  const handleEdit = (data) => {

    navigate(
      "/user/map-gallery-entry",
      {
        state: {
          data: data,
          EditFlag: true,
        },
      }
    );

  };


  /* =========================================================
     APPROVE / REJECT MODAL
  ========================================================= */

  const approveRejectConfirmModal = (
    type,
    approveRejectValue,
    data
  ) => {

    setModal1Open(true);


    if (
      type === "approveRejectModal"
    ) {

      setModalTitle("Verify");

      setFormShowHide(true);

      form.resetFields();


      setImageId(
        data?.imageId
      );


      const filterData =
        commonListData?.filter(
          (item) =>
            item.value ===
            approveRejectValue
        ) || [];


      setModalStatus(
        filterData
      );


      form.setFieldValue(
        "verificationStatus",
        approveRejectValue
      );

    }

  };


  /* =========================================================
     MODAL CLOSE
  ========================================================= */

  const modalClose = () => {

    setModal1Open(false);

    setFormShowHide(false);

    form.resetFields();

  };


  /* =========================================================
     MODAL SUBMIT
  ========================================================= */

  const modalSubmit = async () => {

    try {

      setLoadingModalSubmit(true);


      const payload = {

        imageId:
          imageId,

        verificationStatus:
          form.getFieldValue(
            "verificationStatus"
          ),

        verificationRemark:
          form.getFieldValue(
            "verificationRemark"
          ),

      };


      const res =
        await imageGalleryService.VerifyImageDetails(
          payload
        );


      if (res.data.status) {

        Swal.fire({

          html:
            res.data.message,

          icon:
            "success",

          showConfirmButton:
            false,

          timer:
            2000,

        });

      }
      else {

        Swal.fire({

          icon:
            "error",

          title:
            "Oops...",

          text:
            res.data.message,

        });

      }


      modalClose();

    }
    catch (error) {

      console.error(error);


      Swal.fire({

        icon:
          "error",

        title:
          "Oops...",

        text:
          "Something went wrong.",

      });

    }
    finally {

      setLoadingModalSubmit(false);

    }

  };


  /* =========================================================
     TABLE COLUMNS
  ========================================================= */

  const columns = [

    /* -------------------------------------------------------
       #
    ------------------------------------------------------- */

    {

      title: "#",

      align: "center",

      render: (record) =>
        record.key,

      width: "5%",

    },


    /* -------------------------------------------------------
       IMAGE
    ------------------------------------------------------- */

    {

      title: "Image/Doc",

      align: "center",

      width: "20%",

      render: (row) => {

        const imageUrl =
          row.docUniqueId &&
          imageCacheRef.current[
            row.docUniqueId
          ]
            ? imageCacheRef.current[
                row.docUniqueId
              ]
            : loadingImg;


        return (

          <div
            style={{
              width: "100%",
              height: "180px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #ddd",
              borderRadius: "5px",
              padding: "5px",
              overflow: "hidden",
            }}
          >

            <Image

              src={
                imageUrl
              }

              fallback={
                demoUser
              }

              preview={
                imageUrl !==
                loadingImg
              }

              alt="Map Gallery"

              style={{
                width: "100%",
                height: "168px",
                objectFit: "contain",
              }}

            />

          </div>

        );

      },

    },


    /* -------------------------------------------------------
       MAP IMAGE DETAILS
    ------------------------------------------------------- */

    {

      title:
        "Map Image Details",

      render: (row) => {

        return (

          <div
            style={{
              lineHeight: "1.5",
            }}
          >

            <p
              style={{
                marginBottom: "5px",
              }}
            >

              <span className="fw-bold">
                Notes:
              </span>{" "}

              {row.imagenotes}

            </p>


            <p
              style={{
                marginBottom: "5px",
              }}
            >

              <span className="fw-bold">
                Poster Id:
              </span>{" "}

              {row.imageId}

            </p>


            <p
              style={{
                marginBottom: "5px",
              }}
            >

              <span className="fw-bold">
                Is Visible:
              </span>

              &nbsp;

              <Tag
                color={
                  row.isActive === 0
                    ? "error"
                    : "success"
                }
              >

                {row.isActiveName}

              </Tag>

            </p>


            <p
              style={{
                marginBottom: "5px",
              }}
            >

              <span className="fw-bold">
                Verification Status:
              </span>

              &nbsp;

              <Tag
                color={
                  row.verificationStatus === 0
                    ? "processing"
                    : row.verificationStatus === 1
                    ? "success"
                    : "error"
                }
              >

                {row.statusName}

              </Tag>

            </p>


            <p
              style={{
                marginBottom: "5px",
              }}
            >

              <span className="fw-bold">
                Submit Date:
              </span>{" "}

              {row.submitDate}

            </p>


            {row.verificationStatus !== 0 ? (

              <>

                <p
                  style={{
                    marginBottom: "5px",
                  }}
                >

                  <span className="fw-bold">
                    Verification Date:
                  </span>{" "}

                  {row.publishDate}

                </p>


                <p
                  style={{
                    marginBottom: "5px",
                  }}
                >

                  <span className="fw-bold">
                    Verification Remark:
                  </span>{" "}

                  {row.verificationremark}

                </p>

              </>

            ) : row.actionId > 1 ? (

              <p
                style={{
                  marginBottom: "5px",
                }}
              >

                <span className="fw-bold">
                  Edited Remark:
                </span>{" "}

                {row.verificationremark}

              </p>

            ) : (

              row.verificationremark !== null && (

                <p
                  style={{
                    marginBottom: "5px",
                  }}
                >

                  <span className="fw-bold">
                    Remark:
                  </span>{" "}

                  {row.verificationremark}

                </p>

              )

            )}

          </div>

        );

      },

    },


    /* -------------------------------------------------------
       ACTION
    ------------------------------------------------------- */

    currentUser === "2"

      ? {

          title:
            "Action",

          align:
            "center",

          width:
            "10%",

          render: (data) => (

            <Space
              direction="vertical"
              align="center"
            >

              {data.verificationStatus === 0 &&

                actionStatusData?.map(
                  (elm, id) => (

                    <Button

                      key={id}

                      onClick={() =>
                        approveRejectConfirmModal(
                          "approveRejectModal",
                          elm.value,
                          data
                        )
                      }

                      className={
                        "btn btn-sm " +
                        (
                          elm.value === "3"
                            ? "btn-outline-danger"
                            : elm.value === "1"
                            ? "btn-outline-success"
                            : ""
                        )
                      }

                    >

                      {elm.label}

                    </Button>

                  )
                )}

            </Space>

          ),

        }

      : {

          title:
            "Action",

          align:
            "center",

          width:
            "10%",

          render: (data) => (

            <Space>

              <Button

                className="btn btn-sm btn-outline-primary"

                onClick={() =>
                  handleEdit(data)
                }

              >

                Edit

              </Button>

            </Space>

          ),

        },

  ];


  /* =========================================================
     CLEANUP BLOB URLs
  ========================================================= */

  useEffect(() => {

    return () => {

      Object.values(
        imageCacheRef.current
      ).forEach((url) => {

        if (
          typeof url === "string" &&
          url.startsWith("blob:")
        ) {

          URL.revokeObjectURL(url);

        }

      });


      imageCacheRef.current = {};

    };

  }, []);


  /* =========================================================
     RETURN
  ========================================================= */

  return (

    <>

      {loadingTblData && (
        <Loader />
      )}


      <Container
        style={{
          marginTop: "-30px",
        }}
      >

        <Row
          style={{
            marginTop: "-15px",
          }}
        >

          <Col className="dashboard">

            {/* <Card>

              <Card.Header>

                <h3>
                  Map Gallery List
                </h3>

              </Card.Header>


              <Card.Body> */}

                <Card>

                  <Card.Body>

                    <Row>

                      {/* =====================================
                          ADD NEW
                      ===================================== */}

                      <Col
                        lg={8}
                        md={6}
                        sm={12}
                      >

                        {currentUser === "3" && (

                          <Link

                            className="btn btn-outline-primary mt-1"

                            to="/user/map-gallery-entry"

                          >

                            <IoPersonAddSharp />

                            {" "}Add New

                          </Link>

                        )}

                      </Col>


                      {/* =====================================
                          FILTER
                      ===================================== */}

                      <Col
                        lg={4}
                        md={6}
                        sm={12}
                        className="float-end"
                      >

                        <Form
                          form={form2}
                          initialValues={
                            filterType
                          }
                        >

                          <Form.Item
                            name="filterType"
                            label="Filter"
                          >

                            <Select

                              showSearch

                              placeholder="Select Filter Type"

                              optionFilterProp="children"

                              onChange={
                                loadTableFilter
                              }

                              options={
                                commonListData
                              }

                              loading={
                                loadingFilterList
                              }

                              filterOption={(
                                input,
                                option
                              ) =>
                                (
                                  option?.label ??
                                  ""
                                )
                                  .toLowerCase()
                                  .includes(
                                    input.toLowerCase()
                                  )
                              }

                            />

                          </Form.Item>

                        </Form>

                      </Col>

                    </Row>


                    {/* =====================================
                        TABLE
                    ===================================== */}

                    <div className="tableList">

                      <Table

                        bordered

                        columns={
                          columns
                        }

                        dataSource={
                          tblData
                        }

                        loading={
                          loadingTblData
                        }

                        scroll={{
                          x: 800,
                          y: 400,
                        }}

                        size="small"

                        pagination={{

                          current:
                            currentPage,

                          pageSize:
                            pageSize,

                          total:
                            tblData.length,

                          showSizeChanger:
                            true,

                          pageSizeOptions: [
                            "10",
                            "20",
                            "50",
                            "100",
                          ],

                          hideOnSinglePage:
                            true,

                        }}

                        onChange={
                          handleTableChange
                        }

                      />

                    </div>

                  </Card.Body>

                </Card>

              {/* </Card.Body>

            </Card> */}


            {/* =================================================
                VERIFY MODAL
            ================================================= */}

            <Modal

              title={
                modalTitle
              }

              style={{
                top: 20,
              }}

              open={
                modal1Open
              }

              okButtonProps={{
                hidden: true,
              }}

              cancelButtonProps={{
                hidden: true,
              }}

              onCancel={
                modalClose
              }

              width={
                formShowHide === false
                  ? 900
                  : 450
              }

            >

              {formShowHide && (

                <Form

                  layout="vertical"

                  form={form}

                  name="mapGalleryVerifyForm"

                  onFinish={
                    modalSubmit
                  }

                  scrollToFirstError

                >

                  <Card>

                    <Card.Body>

                      <Col md={12}>

                        <Form.Item

                          name="verificationStatus"

                          label="Status"

                        >

                          <Select

                            showSearch

                            placeholder="Select Status"

                            optionFilterProp="children"

                            options={
                              modalStatus
                            }

                            loading={
                              loadingFilterList
                            }

                            filterOption={(
                              input,
                              option
                            ) =>
                              (
                                option?.label ??
                                ""
                              )
                                .toLowerCase()
                                .includes(
                                  input.toLowerCase()
                                )
                            }

                          />

                        </Form.Item>

                      </Col>


                      <Col
                        md={12}
                        className="clearfix"
                      >

                        <Form.Item

                          label="Remarks"

                          name="verificationRemark"

                          rules={[
                            {
                              required: true,
                              message:
                                "Remarks Required",
                            },
                          ]}

                        >

                          <Input.TextArea

                            showCount

                            rows={3}

                            maxLength={300}

                          />

                        </Form.Item>

                      </Col>


                      <Col md={12}>

                        <hr />

                      </Col>


                      <Col
                        md={12}
                        className="text-center"
                      >

                        <button

                          type="submit"

                          className="btn btn-sm btn-primary me-2"

                          disabled={
                            loadingModalSubmit
                          }

                        >

                          Submit

                        </button>


                        <button

                          type="button"

                          className="btn btn-sm btn-outline-danger"

                          disabled={
                            loadingModalSubmit
                          }

                          onClick={
                            modalClose
                          }

                        >

                          Cancel

                        </button>

                      </Col>

                    </Card.Body>

                  </Card>

                </Form>

              )}

            </Modal>

          </Col>

        </Row>

      </Container>

    </>

  );

};


export default MapGalleryList;